import { CircleNotch } from '@phosphor-icons/react';

const Loading = ({
	size = 22,
	color = 'var(--h-primary)',
	className = '',
}: {
	size?: number;
	color?: string;
	className?: string;
}) => {
	return (
		<div className={`flex flex-row items-center justify-center text-h-primary ${className}`}>
			<CircleNotch
				className='animate-spin'
				size={size}
				weight='bold'
				color={color}
			/>
		</div>
	);
};

export default Loading;
